import React from 'react';
import { Headline } from '../../snippets/Typography';
import Button from '../../snippets/Button/Button';
import { Image, Link } from '../../snippets';
import { Schema } from './TwoTiles.schema';

export function TwoTiles({ cms }) {
  const { section, tiles } = cms;
  const maxWidthClass = section?.fullWidth
    ? 'max-w-none'
    : 'max-w-[var(--content-max-width)]';

  return (
    <div className="px-contained py-20">
      <div
        className={`${maxWidthClass} mx-auto grid gap-x-6 gap-y-12 md:grid-cols-2 lg:gap-x-16`}
      >
        {tiles?.slice(0, 2).map((item, index) => {
          return (
            <div key={index} className="w-full">
              <div
                className={`relative mb-4 bg-offWhite h-[220px] lg:h-[380px] w-full`}
              >
                <Link
                  aria-label={item.heading}
                  href={item.link?.url}
                  newTab={item.link?.newTab}
                  tabIndex="-1"
                >
                  {item?.image?.src && (
                    <Image
                      alt={item.alt}
                      className={`${item.position}`}
                      fill
                      sizes="(min-width: 1024px) 40vw, 100vw"
                      src={item.image.src}
                    />
                  )}
                </Link>
              </div>

              <div className="flex flex-col items-start">
                <Link
                  aria-label={item.heading}
                  href={item.link?.url}
                  newTab={item.link?.newTab}
                >
                  <div className="group flex">
                    <Headline variant="h4" element="h4" className="pb-4">
                      {item.heading}
                    </Headline>
                  </div>
                </Link>

                {item?.link && (
                  <Button
                    href={item?.link?.url}
                    theme="primary"
                    variant="filled"
                  >
                    {item?.link?.text}
                  </Button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

TwoTiles.displayName = 'TwoTiles';
TwoTiles.Schema = Schema;
